import {
  FLASH_MESSAGE,
  FLASH_MESSAGE_RESET,
} from '../constants/actions';
import { isSessionHandoffInProgress } from '../utils/session';

export function flashMessage({ header, message, list, icon, color, type, autoHideDuration }) {
  return {
    type: FLASH_MESSAGE,
    payload: {
      header,
      message,
      list,
      color,
      icon,
      show: true,
      type,
      autoHideDuration: autoHideDuration || 3500,
    },
  };
}

export function flashSuccessMessage({ header, message, autoHideDuration, icon }) {
  return (dispatch) => {
    dispatch(flashMessage({ header: header || 'Success', message, icon: icon || 'checkmark', type: 'success', autoHideDuration: autoHideDuration || 3500 }));
  };
}

export function flashErrorMessage({ header, message, list, autoHideDuration, icon }) {
  return (dispatch) => {
    // During a session-takeover hand-off the page is navigating to /logout and every in-flight
    // request is failing at once; a generic error flash on top of that is noise the user cannot
    // act on. Stay silent — the redirect is the response.
    if (isSessionHandoffInProgress()) {
      return;
    }
    dispatch(flashMessage({ header: header || 'Error', message, list, icon: icon || 'warning sign', type: 'error', autoHideDuration: autoHideDuration || 3500 }));
  };
}

export function resetFlashMessage() {
  return {
    type: FLASH_MESSAGE_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/actions/flash.js